module.exports = __webpack_public_path__ + "static/media/logoLOL.2ab52053.svg";